import { render, staticRenderFns } from "./Light.vue?vue&type=template&id=5b01709d&scoped=true&"
import script from "./Light.vue?vue&type=script&lang=js&"
export * from "./Light.vue?vue&type=script&lang=js&"
import style0 from "./Light.vue?vue&type=style&index=0&id=5b01709d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b01709d",
  null
  
)

export default component.exports